export default "__VITE_ASSET__CThHoQ1c__"